import { createAction, createReducer } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  todosRequerimentos: { list: [], numberPage: 1, sizePage: 10, totalRecords: 0 },
};

export const duckCleanRelatorioTodosRequerimentos = createAction('DUCK_CLEAN_RELATORIO_TODOS_REQUERIMENTOS');
export const duckRelatorioTodosRequerimentos = createAction('DUCK_RELATORIO_TODOS_REQUERIMENTOS');

export default createReducer(INITIAL_STATE, {
  [duckRelatorioTodosRequerimentos.type]: (state, action) => ({
    ...state,
    todosRequerimentos: action.payload,
  }),
  [duckCleanRelatorioTodosRequerimentos.type]: state => ({
    ...state,
    todosRequerimentos: INITIAL_STATE.todosRequerimentos,
  }),
});
